export default __webpack_public_path__ + "static/media/img_3.9b36c62f.jpg";